<nz-layout>
  <nz-header class="section-header">
    {{ "Initial Assessments" | translate }}
  </nz-header>
  <nz-content>
    <!-- <app-social-history-questonaire /> -->

    @for (cm of submenu; track cm) {
      @if (cm.path == componentPaths.socialQuestionnaireAmen) {
        <app-questionnaire-history-table
          [id]="cm.path"
          [questionnaireTemplateId]="1"
          [historyItems]="getTemplateItems(1)"
          [currentVisitId]="currentVisitId()"
          [isLoading]="isOverviewLoading"
          [error]="overviewError"
          [showAddButton]="isVisitMode()"
          (addRequested)="openVisitQuestionnaire($event)"
          (submissionSelected)="openQuestionnaireSubmission($event)"
          (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
        />
      }
      @if (cm.path == componentPaths.supportingDocumentsAmen) {
        <app-supporting-documents
          [id]="cm.path"
          [isLoading]="isLoading"
          [pagination]="false"
          />
      }
      @if (cm.path == componentPaths.fastProtocolQuestionnaireMediterrenean) {
        <app-questionnaire-history-table
          [id]="cm.path"
          [questionnaireTemplateId]="2"
          [historyItems]="getTemplateItems(2)"
          [currentVisitId]="currentVisitId()"
          [isLoading]="isOverviewLoading"
          [error]="overviewError"
          [showAddButton]="isVisitMode()"
          (addRequested)="openVisitQuestionnaire($event)"
          (submissionSelected)="openQuestionnaireSubmission($event)"
          (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
        />
      }
    }
  </nz-content>
</nz-layout>
